import axios from "axios";
import { getToken, logout } from "./auth";

export const api = axios.create({
  httpAgent: false,
  // baseURL: "http://127.0.0.1:8000/api"
  // baseURL: "https://backend.walletlote.app.br/api",
  baseURL: "https://sandbox.walletlote.app.br/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token} `;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, config } = error.response;
      const { url } = config;

      if (
        status === 401 &&
        error.response.data.error !== "Credenciais inválida." &&
        url !== "schedules"
      ) {
        logout();
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
      //   else if (
      //   status === 404 &&
      //   error.response.data.error !== "Cep não encontrado" &&
      //   error.response.data.error !== "Doc invalid." &&
      //   error.response.data.error !== "Cnpj não encontrado" &&
      //   error.response.data.error !== "Usuário não encontrado."
      // ) {
      //   window.history.pushState({}, '', '/404');
      //   window.dispatchEvent(new PopStateEvent('popstate'));
      // } else if (status === 403) {
      //   window.history.pushState({}, '', '/403');
      //   window.dispatchEvent(new PopStateEvent('popstate'));
      // } else if (status === 429) {
      //   return;
      // }
      // else if (status === 500) {
      //   return;
      //   // window.history.pushState({}, '', '/500');
      //   // window.dispatchEvent(new PopStateEvent('popstate'));
      // }
    }
    return Promise.reject(error);
  }
);
